<div class="modal-header">
    <h5 class="modal-title">Portfolio samenstellen</h5>
    <div>
        <a (click)="close()" title="Annuleren" class="btn btn-transparent mr-2">Sluiten</a>
    </div>
</div>
<div class="modal-body p-5">

    <ng-container *ngIf="loading">
        <div class="centerLoading">
            <i class="fa-solid fa-spinner"></i>
        </div>
    </ng-container>

    <div [class]="loading ? 'd-none' : ''">
        <ng-container>
            <div class="form-container" [class]="fetchedPDF ? 'show-iframe' : ''">
                <h4>Personaliseer je portfolio</h4>
                <form target="portfolioPDF" method="POST" id="NameInputForm" [action]="portfolioPDFUrl">
                    <div class="form-group">
                        <input type="text" name="name" id="name" (keyup.enter)="submit()"
                            placeholder="Emma de Vries"
                            class="form-control"/>
    
                        <input type="hidden" name="portfolioItemIds" [value]="portfolioIds.join(',')">
                        <p><small>Als je een naam aan je portfolio wilt toevoegen, vul deze dan in. Anders gebruiken we de naam uit je profiel.</small></p>
                    </div>
                    <button class="btn btn-success" (click)="submit()" type="submit">Portfolio samenstellen</button>
                </form>
            </div>
            <iframe id="portfolioPDF" style="height:600px;" type="application/pdf" [class]="fetchedPDF ? 'show-iframe' : ''">

            </iframe>
        </ng-container>
    </div>
</div>
<div class="modal-footer" *ngIf="showButtons">
    <button class="btn btn-success mr-2" (click)="downloadPDF()"><span>Downloaden</span></button>
    <button class="btn btn-warning" (click)="printPDF()"><span>Afdrukken</span></button>
</div>